import { useState, memo } from "react"
import { ChevronRight } from "lucide-react"
import { LayerItem } from "./layer-item"
import type { LayerDefinition } from "@/types/explore"

export interface CollapsibleSubgroupProps {
  label: string
  layers: LayerDefinition[]
  activeLayers: string[]
  toggleLayer: (id: string) => void
  quickLayers: string[]
  onToggleQuick: (id: string) => void
  onFilterChange?: (layerId: string, filterId: string, value: unknown) => void
  forceOpen?: boolean
}

export const CollapsibleSubgroup = memo(
  ({
    label,
    layers,
    activeLayers,
    toggleLayer,
    quickLayers,
    onToggleQuick,
    onFilterChange,
    forceOpen,
  }: CollapsibleSubgroupProps) => {
    const [open, setOpen] = useState(false)
    const isOpen = open || forceOpen
    const activeInGroup = layers.filter((l) => activeLayers.includes(l.id)).length

    return (
      <div className="mt-0.5">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-1.5 w-full py-1.5 px-2 rounded-lg hover:bg-gray-50/80 transition-colors duration-150"
        >
          <ChevronRight
            className={`w-3 h-3 text-gray-300 transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`}
          />
          <span className="text-sm text-gray-400">{label}</span>
          {activeInGroup > 0 && (
            <span className="text-xs font-bold text-primary bg-primary/[0.08] rounded-full px-1.5 py-0.5 leading-none ml-auto tabular-nums">
              {activeInGroup}
            </span>
          )}
        </button>
        {isOpen && (
          <div className="ml-3 pl-3 border-l-2 border-gray-100 mt-0.5 subgroup-content">
            {layers.map((layer) => (
              <LayerItem
                key={layer.id}
                layer={layer}
                active={activeLayers.includes(layer.id)}
                onToggle={() => toggleLayer(layer.id)}
                isQuick={quickLayers.indexOf(layer.id) !== -1 ? quickLayers.indexOf(layer.id) + 1 : undefined}
                onToggleQuick={onToggleQuick}
                onFilterChange={onFilterChange ? (fId, v) => onFilterChange(layer.id, fId, v) : undefined}
              />
            ))}
          </div>
        )}
      </div>
    )
  },
)
